import React from 'react';
import { Row, Col, Icon } from 'antd';
import util from '../../util/util'
// import axios from '../../axios/index'
import './index.less'
export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentWillMount() {
        this.setState({
            userName: 'xxxx'
        })
        setInterval(() => {
            let sysTime = util.formateDate(new Date().getTime());
            this.setState({
                sysTime
            })
        }, 1000);
    }

    render() {
        return (
            <div className='header'>
                <Row className='header-top'>
                    <Col span='4' className='time'>
                        <span className="myself">MySelf</span>
                        <span className='now-time'>{this.state.sysTime}</span>
                    </Col>
                    <Col span='18' className='left-content'>
                        <a href='#/home/list'>首页</a>
                        <a href='#/home/list'>分类</a>
                        <a href='#/home/list'>关于</a>
                        <a href='#/home/list'><Icon type="search" /></a>
                    </Col>
                    {/* <Col span={menuType ? 18 : 24}>
                        <span>欢迎，{this.state.userName}</span>
                        <a href='#'>退出</a>
                    </Col> */}
                </Row>
                {/* {
                    menuType ? '' :
                        <Row className='breadcrumb'>
                            <Col span='4' className='breadcrumb-title'>
                                首页
                            </Col>
                            <Col span='20' className='weather'>
                                <span className='date'>{this.state.sysTime}</span>
                                <span className='weather-img'>
                                    <img src={this.state.dayPicUrl} alt='' />
                                </span>
                                <span className='weather-detail'>
                                    {this.state.weather}
                                </span>
                            </Col>
                        </Row>
                } */}
            </div>
        );
    }
}